import { userEmail, userId } from '@gonfalon/constants/constants';
import { postTracking } from '@gonfalon/openapi/operations/postTracking';

export const trackEventsViaInternalApi = async (event: string, properties: { [key: string]: string }) => {
  const enriched: Record<string, string> = { ...properties };
  const id = userId();
  if (id !== undefined && !('userId' in properties)) {
    enriched.userId = id;
  }
  const email = userEmail();
  if (email !== undefined && !('userEmail' in properties)) {
    enriched.userEmail = email;
  }

  const response = await postTracking(
    {
      body: {
        event,
        Properties: enriched,
      },
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'LD-Bypass-UA-Tracking': '',
      },
    },
  );
  if (response.response.ok) {
    return;
  } else {
    throw new Error('failed to create analytics event');
  }
};
